import { VIP_PIX_DISCORD_NOTICE } from '@/constants/vipPixDiscordNotice';

type PixDiscordPaymentNoticeProps = {
    className?: string;
};

export function PixDiscordPaymentNotice({ className = '' }: PixDiscordPaymentNoticeProps) {
    return (
        <div
            role="note"
            className={`rounded-xl border border-orange-500/25 bg-orange-500/[0.07] px-4 py-3 text-center text-[11px] leading-relaxed text-white/75 sm:text-xs ${className}`}
        >
            {VIP_PIX_DISCORD_NOTICE}
        </div>
    );
}
